.root {
    padding-top: 2rem;
}

.buttons {
    display: flex;
    justify-content: center;
}

.buttons:first-child {
    margin-bottom: 2rem;
}
 
* ~ .buttons {
    margin-top: 2rem;
}

.buttons > * + * {
    margin-left: 0.5rem;
}

.grid {
    margin: 0;
    display: grid;
    gap: 2rem 1rem;
    grid-gap: 2rem 1rem;
    grid-template-columns: 1fr;
    grid-auto-flow: dense;
    list-style: none;
    padding: 0;
    position: relative;
}

.progress {
    margin-top: 2rem;
    text-align: center;
}

.progressWrapper {
    display: flex;
    width: 100%;
    max-width: 200px;
    margin: 1rem auto 0;
    overflow: hidden;
    background-color: rgb(var(--color-gray-300));
    border-radius: 2px;
}

.progressBar {
    width: 100%;
    height: 4px;
    background-color: rgb(var(--color-gray-900));
    display: block;
    transform: translate(-100%);
}

/* 
.advert:nth-child(1) {
    grid-row: 4;
}

.advert:nth-child(2) {
    grid-row: 18;
}

.advert:nth-child(3) {
    grid-row: 30;
}

.advert:nth-child(4) {
    grid-row: 42;
}
*/

@media (min-width: 360px) {
    .grid {
        grid-template-columns: repeat(2, 1fr);
    }
    /* 
    .advert {
        grid-column: 2;
    }
    */
    .large:nth-child(n+2)  {
        grid-column: span 2;
    }

    .advert:nth-child(1).large {
        grid-column: 1 / span 2;
    }

    /* .advert:nth-child(n+2) {
        grid-column: 1;
    }

    .large:nth-child(3)  {
        grid-column: span 2;
    }

    .advert:nth-child(1) {
        grid-row: 3;
    }
    
    .advert:nth-child(2) {
        grid-row: 7;
    }
    
    .advert:nth-child(3) {
        grid-row: 13;
    }
    
    .advert:nth-child(4) {
        grid-row: 19;
    } */
}

@media (min-width: 900px) {
    .grid {
        grid-template-columns: repeat(3, 1fr);
    }
    /* 
    .advert {
        grid-column: 3;
    } 
    */
    .large:nth-child(3)  {
        grid-column: span 2; 
    }
     
    .advert:nth-child(1).large { 
        grid-column: 2 / span 2;
        grid-row:1;
    }
    /*
    .advert:nth-child(1) {
        grid-row: 1;
    }
    
    .advert:nth-child(2) {
        grid-row: 5;
    }
    
    .advert:nth-child(3) {
        grid-row: 9;  
    }
    
    .advert:nth-child(4) { 
        grid-row: 13;
    }
    */
}

@media (min-width: 1300px) {  
    .grid {
        grid-template-columns: repeat(4, 1fr); 
    }
    
    /* 
    .advert {
        grid-column: 4;
    }
    */

    .large:nth-child(3)  {
        grid-column: span 2;
    }

    .large:nth-child(n+2)  {
        grid-column: span 2;
    }

    .advert:nth-child(1).large {
        grid-column: 3 / span 2;
        grid-row:1;
    }
    /* 
    .advert:nth-child(n+2) {
        grid-column: 1;
    }

    .advert:nth-child(1) {
        grid-row: 3;
    }
    
    .advert:nth-child(2) {
        grid-row: 5;
    }
    
    .advert:nth-child(3) {
        grid-row: 7;
    }
    
    .advert:nth-child(4) {
        grid-row: 9;
    }
     */
}
.advert {
    /* border-radius: 10px;
    overflow: hidden; */
}